import { doIndexPreFlight } from "./doIndexPreFlight";
import { Globals } from "../CoreApp/Globals";
import { appstr } from "./appstr.js";

export function doPagePreFlight() {
  if (Globals._preflightInfo == null) return;

  var i = Globals._preflightInfo.fPageIndex++;
  var scm = Globals._preflightInfo.fSCM;
  var plm = Globals._preflightInfo.fPLM;
  var pp = Globals._preflightInfo.fPubPanel;
  if (Globals._pubSettings.fPubScope == "MultiChart") {
    var docmgr = pp.fWSMgr.GetDocMgr();
    scm.fBranchRoot = null;
    var curDocPages = scm.GetActiveBranchPages();
    if (Globals._preflightInfo.fPageIndex - Globals._preflightInfo.fCompletedPages > curDocPages) {
      Globals._preflightInfo.fCompletedPages += curDocPages;
      Globals._preflightInfo.fCurDocIdx++;
    }

    var curDoc = docmgr.GetIndexDoc(Globals._preflightInfo.fCurDocIdx);
    scm = curDoc.GetSubChartMgr();
    plm = curDoc.GetPageLayoutMgr();
    Globals._preflightInfo.fSCM = scm;
    Globals._preflightInfo.fCanvasPanel = curDoc.fCanvasRef;
    Globals._preflightInfo.fCanvasPanel.SetShownState(false);
    var sc = scm.GetSubChartByPageNum(
      Globals._preflightInfo.fPageIndex - Globals._preflightInfo.fCompletedPages
    );
  } else var sc = scm.GetSubChartByPageNum(i + 1);

  var doc = scm.GetDoc();
  doc.SubChartSwitch(sc);

  // Fast path: if data already loaded (custom charts), skip polling
  if (sc.fPageLoaded !== false && doc.SubChartDataLoaded(sc)) {
    setTimeout(function () {
      finishSCLoad(sc, plm);
    }, 0);
  } else {
    checkSCLoaded(sc, plm);
  }

  function checkSCLoaded(sc, plm) {
    var scm = Globals._preflightInfo.fSCM;
    var doc = scm.GetDoc();
    if (sc.fPageLoaded === false || !doc.SubChartDataLoaded(sc)) {
      setTimeout(checkSCLoaded.bind(this, sc, plm), 10);
    } else {
      setTimeout(finishSCLoad.bind(this, sc, plm), 0);
    }
  }
  function finishSCLoad(subChart, plm) {
    var scm = Globals._preflightInfo.fSCM;
    var cp = Globals._preflightInfo.fCanvasPanel;
    var pp = Globals._preflightInfo.fPubPanel;
    var doc = scm.GetDoc();
    if (subChart != null) {
      if (!Globals._preflightInfo.fShowSCNum) {
        var scName = subChart.GetSubChartName();
        var scname_lower = scName.toLowerCase();
        if (Globals._preflightInfo.fNameList.has(scname_lower))
          Globals._preflightInfo.fShowSCNum = true;
        else Globals._preflightInfo.fNameList.add(scname_lower);
      }

      if (subChart.fPageLoaded === false) {
        Globals._preflightInfo.fPageIndex--;
        doPagePreFlight();
        return;
      }
      cp.fBackgroundPanel.SetHasVertScrollBar(false);
      var sw = plm.GetPageWidth();
      var sh = plm.GetPageHeight();
      Globals._publishScaler.AddPage(sw, sh);
    }

    if (Globals._preflightInfo.fNumPages > 30) {
      var msg =
        appstr("loadingpages") +
        " " +
        Globals._preflightInfo.fPageIndex.toString() +
        " " +
        appstr("of") +
        " " +
        Globals._preflightInfo.fNumPages.toString();
      pp.UpdateProgress2(msg, false);
    }

    if (Globals._preflightInfo.fPageIndex < Globals._preflightInfo.fNumPages) {
      setTimeout(function () {
        doPagePreFlight();
      }, 0);
    } else if (Globals._pubSettings.fDoIndex) {
      scm.CreateIndexSubChart();
      setTimeout(function () {
        doIndexPreFlight(0);
      }, 1);
    } else if (Globals._pubSettings.fDoFunctionStatements) {
      scm.CreateFunctionalStatementSubchart();
      setTimeout(function () {
        doIndexPreFlight(0);
      }, 1);
    } else {
      Globals._preflightInfo.fPubPanel.DoPublishBookComplete(
        Globals._preflightInfo.fShowSCNum,
        Globals._preflightInfo.fXMLOutputType
      );
      Globals._preflightInfo = null;
    }
  }
}
